<div class="wallet-details-container">
    <section class="">
        <mapfre-alert [closeButton]="true" [notTop]="false"></mapfre-alert>
    </section>
    <div [ngClass]="{'shows':!loading, 'hides':loading}">
        <div #portalOneContainer class="portalOneContainer"></div>
    </div>
    <div [ngClass]="{'shows':loading, 'hides':!loading}">
        <div class="loader-container">

            <mapfre-loading></mapfre-loading>
        </div>
    </div>

</div>